/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.LOCATION_WEBSITES_RECEIVE]: (state, action) => {

            return reduce(
                action.payload.locationWebsites,
                (memo, locationWebsite) => {
                    const { id } = locationWebsite;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = locationWebsite;
                    return memo;
                },
                state,
            );
        },
        [actions.DELETE_LOCATION_WEBSITE_SUCCESS]: (state, action) => {
            const locationWebsiteId = get(action, ['payload', ['locationWebsiteId']]);
            const items = { ...state };
            return omitBy(items, { id: locationWebsiteId })
        }
    },
);